// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBFeatureItems.SDBFeatureItems.SS2Model", [
  "Backbone",
  "Utils",
], function (Backbone, Utils) {
  "use strict";

  // @class Case.Fields.Model @extends Backbone.Model
  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath(
        "Modules/SDBFeatureItems/SuiteScript2/SDBFeatureItems.Service.ss"
      ),
      true
    ),
  });
});
